namespace advisorop.services {
    `use strict`;

    export class ManagerApi {

        readonly apiUrl = `/api/manager`;
        
        static $inject = [`$http`];
        constructor(private $http: ng.IHttpService) {
        }       

        searchProductOrManager(searchTerm: string): ng.IHttpPromise<any[]> {
            return this.$http.get(`${this.apiUrl}/search-product-or-manager?searchTerm=${searchTerm}`);
        }

        searchSecProductOrManager(searchTerm: string, searchManagers: boolean, searchProducts: boolean, searchSecurities: boolean): ng.IHttpPromise<any[]> {
            return this.$http.get(`${this.apiUrl}/search-sec-product-or-manager?searchTerm=${searchTerm}&searchManagers=${searchManagers}&searchProducts=${searchProducts}&searchSecurities=${searchSecurities}`);
        }
    }
    angular.module(Constants.ADVOP_SERVICES).service("managerApi", ManagerApi);
}
